import React, { useEffect, useState } from 'react';
import { Table, Tag, Card, Button, Drawer, Form, Input, Upload, Select, DatePicker, Space, message, Switch, Tooltip, Typography, Row, Col } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { UserService } from '../../../Services/Manage/UserService';
import { LetterService } from '../../../Services/Manage/LetterService';
import useMessage from 'antd/es/message/useMessage';
import { ENDPOINT } from '../../../Services/ENDPOINT';
import { Image } from 'antd';



const normalizeUrl = (base, path) => {
    if (!path) return null;
    if (path.startsWith("http")) return path;
    return `${base.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;
};
const getPermission = (link) => {

    try {
        const raw = localStorage.getItem("ome_permission");
        const parsed = JSON.parse(raw);
        const permissions = Array.isArray(parsed) ? parsed : JSON.parse(parsed);
        return permissions.find(p => p.link === link) || { add: false, edit: false, delete: false, read: false };
    } catch { return { add: false, edit: false, delete: false, read: false }; }
};


const LetterHeader = () => {

    const perm = getPermission('/manage-letter-formats');
    const [data, setData] = useState([]);

    const [drawerVisible, setDrawerVisible] = useState(false);
    const [editingItem, setEditingItem] = useState(null);
    const [form] = Form.useForm();
    const [message, messageContxt] = useMessage();
    const [uploadList, setUploadList] = useState([]);
    const [orgDetails, setOrgDetails] = useState(null);
    const [editingOrg, setEditingOrg] = useState(false);
    const [orgForm] = Form.useForm();
    const [savingOrg, setSavingOrg] = useState(false);

    const statusColors = {
        'Inactive': 'default',
        'Active': 'green',
    };

    const getAllLetterhead = async () => {
        try {
            const request = await LetterService.getAllHead();
            if (request.data && Array.isArray(request.data)) {
                const mappedData = request.data.map((item, index) => ({
                    ...item,
                    si_no: index + 1,
                    image_url: normalizeUrl(ENDPOINT.base, item.image_url),
                }));
                setData(mappedData);
            }
        } catch (err) {
            console.error(err);
        }
    };
    const getOrgDetails = async () => {
        try {
            const request = await LetterService.getAllFooter();
            const record = (request.data || [])[0] || null;
            setOrgDetails(record);
            if (record) {
                orgForm.setFieldsValue(record);
            }
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        getAllLetterhead();
        getOrgDetails();
    }, [])
    const columns = [
        {
            title: 'S. No.',
            dataIndex: 'si_no',
            key: 'si_no',
        },
        {
            title: 'Title',
            dataIndex: 'title',
            key: 'title',
        },
        {
            title: 'Image',
            dataIndex: 'image_url',
            key: 'image_url',
            render: (url) => {
                if (!url) return 'No Image';
                const fullUrl = normalizeUrl(ENDPOINT.base, url);
                return (
                    <img
                        src={fullUrl}
                        alt="Letter Header"
                        style={{
                            width: 100,
                            height: 100,
                            objectFit: 'cover',
                            borderRadius: 6,
                            border: '1px solid #ddd',
                        }}
                        onError={(e) => {
                            e.target.onerror = null;
                            // e.target.src = 'https://via.placeholder.com/100?text=No+Image';
                        }}
                    />
                );
            },
        },

        {
            title: 'Tag',
            dataIndex: 'tag',
            key: 'tag',
            render: (tag) => <Tag style={{ fontSize: '16px', padding: '6px 12px' }} color="blue">{tag}</Tag>
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status) => (
                <Tag
                    style={{ fontSize: '16px', padding: '6px 12px' }}
                    color={statusColors[status] || 'default'}
                >
                    {status ? status.toUpperCase() : 'N/A'}
                </Tag>
            ),
        },

        {
            title: 'Actions',
            key: 'actions',
            fixed: 'right',
            render: (text, record) => (
                <Space size="middle">
                    <Tooltip title={!perm.edit ? "You don't have permission to edit" : ""}>
                        <Button
                            size='large'
                            icon={<EditOutlined />}
                            onClick={() => handleEdit(record)}
                            disabled={!perm.edit}
                        />
                    </Tooltip>
                    <Tooltip title={!perm.delete ? "You don't have permission to delete" : ""}>
                        <Button
                            size='large'
                            danger
                            icon={<DeleteOutlined />}
                            onClick={() => handleDelete(record)}
                            disabled={!perm.delete}
                        />
                    </Tooltip>
                </Space>
            ),
        },
    ];

    const showDrawer = () => {
        setEditingItem(null);
        form.resetFields();
        setUploadList([]);
        setDrawerVisible(true);
    };

    const handleEdit = async (record) => {
        setEditingItem(record);

        const imageFileList = record.image_url
            ? [{
                uid: "-1",
                name: record.title || "Uploaded Image",
                status: "done",
                url: record.image_url.startsWith("http")
                    ? record.image_url
                    : normalizeUrl(ENDPOINT.base, record.image_url),
            }]
            : [];

        form.setFieldsValue({
            ...record,
            status: record.status === "Active",
            image_url: imageFileList,
        });

        setUploadList(imageFileList);
        setDrawerVisible(true);
    };


    const handleDelete = async (record) => {
        try {
            const request = await LetterService.deleteHead(record.id);
            if (request.status) {
                message.success(request.message);
                getAllLetterhead();
            } else {
                message.error(request.message);
            }
        } catch (error) {
            console.log(error);
            message.warning(error);
        }
    };

    const handleDrawerClose = () => {
        setDrawerVisible(false);
        form.resetFields();
        setUploadList([]);
    };

    const onFinish = async (values) => {
        const user = await UserService.getOmeUser();

        let imageUrl = null;


        if (values.image_url && values.image_url.length > 0) {
            const file = values.image_url[0];

            if (file.response?.image?.path) {

                imageUrl = file.response.image.path;
            } else if (file.url && file.url.includes("/uploads/")) {

                imageUrl = file.url.replace(`${ENDPOINT.base}/`, "");
            } else {
                imageUrl = null;
            }

        }

        const newItem = {
            ...values,
            added_by: user.uid,
            status: values.status ? "Active" : "Inactive",
            image_url: imageUrl,
        };

        try {
            if (editingItem) {
                const request = await LetterService.updateHead(newItem, editingItem.id);
                if (request.status) {
                    message.success(request.message);
                    getAllLetterhead();
                } else {
                    message.error(request.message);
                }
            } else {
                const request = await LetterService.createHead(newItem);
                if (request.status) {
                    message.success(request.message);
                    getAllLetterhead();
                } else {
                    message.error(request.message);
                }
            }
        } catch (err) {
            message.error(err.message);
        } finally {
            setDrawerVisible(false);
            form.resetFields();
        }
    };

    const handleSaveOrgDetails = async (values) => {
        setSavingOrg(true);
        try {
            let request;
            if (orgDetails?.id) {
                request = await LetterService.updateFooter(values, orgDetails.id);
            } else {
                request = await LetterService.createFooter(values);
            }
            if (request.status) {
                message.success(request.message || "Company details saved");
                setEditingOrg(false);
                getOrgDetails();
            } else {
                message.error(request.message || "Failed to save");
            }
        } catch (err) {
            console.error(err);
            message.error("Failed to save company details");
        } finally {
            setSavingOrg(false);
        }
    };

    const handleDeleteOrgDetails = async () => {
        if (!orgDetails?.id) return;
        try {
            const request = await LetterService.deleteFooter(orgDetails.id);
            if (request.status) {
                message.success(request.message || "Company details deleted");
                setOrgDetails(null);
                orgForm.resetFields();
            } else {
                message.error(request.message || "Failed to delete");
            }
        } catch (err) {
            console.error(err);
            message.error("Failed to delete company details");
        }
    };

    return (
        <div>
            <Card
                title="Headers"
                extra={
                    <Tooltip title={!perm.add ? "You don't have permission to create" : ""}>
                        <Button
                            type="primary"
                            size='large'
                            icon={<PlusOutlined />}
                            onClick={showDrawer}
                            disabled={!perm.add}
                        >
                            Add Header
                        </Button>
                    </Tooltip>
                }
            >
                <Table
                    columns={columns}
                    dataSource={data}
                    pagination={{ pageSize: 10 }}
                    scroll={{ x: true }}
                />
            </Card>

            <Card
                title="Company Details (used on Quotation / Invoice)"
                style={{ marginTop: 16 }}
                extra={
                    !editingOrg ? (
                        <Space>
                            <Button type="primary" onClick={() => setEditingOrg(true)}>
                                {orgDetails ? "Edit" : "Add Details"}
                            </Button>
                            {orgDetails && (
                                <Button danger onClick={handleDeleteOrgDetails}>
                                    Delete
                                </Button>
                            )}
                        </Space>
                    ) : null
                }
            >
                {editingOrg ? (
                    <Form
                        form={orgForm}
                        layout="vertical"
                        onFinish={handleSaveOrgDetails}
                        initialValues={orgDetails || {}}
                    >
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item name="company_name" label="Company Name (beside logo)">
                                    <Input size="large" placeholder="ShreeshTech" />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item name="company_subtitle" label="Company Subtitle (beside logo)">
                                    <Input size="large" placeholder="Business Automation" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item name="tagline" label="Tagline / Services (line 1)">
                                    <Input size="large" placeholder="ERP Software | Web Development | Mobile Apps | Cloud Hosting" />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item name="tagline_2" label="Tagline / Services (line 2)">
                                    <Input size="large" placeholder="Digital Marketing | IT Consultancy | SMS & WhatsApp API" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item name="signature_text" label="Signature Text (bottom of PDF)">
                                    <Input size="large" placeholder="For ShreeshTech Solutions Pvt. Ltd." />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Form.Item>
                            <Space>
                                <Button type="primary" htmlType="submit" loading={savingOrg}>
                                    Save
                                </Button>
                                <Button onClick={() => { setEditingOrg(false); orgForm.setFieldsValue(orgDetails || {}); }}>
                                    Cancel
                                </Button>
                            </Space>
                        </Form.Item>
                    </Form>
                ) : orgDetails ? (
                    <div>
                        <Row gutter={16} style={{ marginBottom: 14 }}>
                            <Col span={12}>
                                <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                    Company Name (beside logo)
                                </Typography.Text>
                                <div style={{ fontWeight: 600, marginTop: 2 }}>
                                    {orgDetails.company_name || "-"}
                                </div>
                            </Col>
                            <Col span={12}>
                                <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                    Company Subtitle (beside logo)
                                </Typography.Text>
                                <div style={{ fontWeight: 600, marginTop: 2 }}>
                                    {orgDetails.company_subtitle || "-"}
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={16} style={{ marginBottom: 14 }}>
                            <Col span={12}>
                                <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                    Tagline / Services (line 1)
                                </Typography.Text>
                                <div style={{ fontWeight: 600, marginTop: 2 }}>
                                    {orgDetails.tagline || "-"}
                                </div>
                            </Col>
                            <Col span={12}>
                                <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                    Tagline / Services (line 2)
                                </Typography.Text>
                                <div style={{ fontWeight: 600, marginTop: 2 }}>
                                    {orgDetails.tagline_2 || "-"}
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                    Signature Text (bottom of PDF)
                                </Typography.Text>
                                <div style={{ fontWeight: 600, marginTop: 2 }}>
                                    {orgDetails.signature_text || "-"}
                                </div>
                            </Col>
                        </Row>
                    </div>
                ) : (
                    <Typography.Text type="secondary">No company details added yet.</Typography.Text>
                )}
            </Card>


            {messageContxt}
            <Drawer
                title={editingItem ? "Edit Header" : "Add New Header"}
                width={500}
                onClose={handleDrawerClose}
                visible={drawerVisible}
                bodyStyle={{ paddingBottom: 80 }}
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                >
                    <Form.Item
                        name="title"
                        label="Title"
                    >
                        <Input size='large' placeholder='Add header title for reference' />
                    </Form.Item>

<Form.Item
                        name="tag"
                        label="Tag"
                    >
                        <Select size="large" placeholder="Select title type">
                            <Select.Option value="header">Header</Select.Option>
                            <Select.Option value="footer">Footer</Select.Option>
                            {/* <Select.Option value="watermark">Watermark</Select.Option> */}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="image_url"
                        label="Image"
                        valuePropName="fileList"
                        getValueFromEvent={e => Array.isArray(e) ? e : e?.fileList}
                    >
                        <Upload
                            listType="picture-card"
                            maxCount={1}
                            fileList={uploadList}
                            beforeUpload={(file) => {
                                return new Promise((resolve, reject) => {
                                    const img = new window.Image();
                                    const objectUrl = URL.createObjectURL(file);
                                    img.onload = () => {
                                        URL.revokeObjectURL(objectUrl);

                                        const tag = form.getFieldValue('tag');
                                        const dims = {
                                            header: { w: 327, h: 320 },
                                            footer: { w: 1391, h: 54 },
                                        };
                                        const expected = dims[tag];

                                        if (!tag) {
                                            message.error("Please select a Tag first.");
                                            reject(Upload.LIST_IGNORE);
                                            return;
                                        }

                                        if (expected && (img.width !== expected.w || img.height !== expected.h)) {
                                            message.error(
                                                `Image must be exactly ${expected.w} x ${expected.h} px for ${tag}. Uploaded image is ${img.width} x ${img.height} px.`
                                            );
                                            reject(Upload.LIST_IGNORE);
                                            return;
                                        }

                                        resolve(file);

                                    };
                                    img.onerror = () => {
                                        URL.revokeObjectURL(objectUrl);
                                        message.error("Invalid image file.");
                                        reject(Upload.LIST_IGNORE);
                                    };
                                    img.src = objectUrl;
                                });
                            }}
                            onChange={({ fileList }) => {
                                setUploadList(fileList);
                                form.setFieldsValue({ image_url: fileList });
                            }}
                            customRequest={async ({ file, onSuccess, onError }) => {
                                const formData = new FormData();
                                formData.append("image", file);

                                try {
                                    const res = await fetch(`${ENDPOINT.Head}/upload-image`, {
                                        method: "POST",
                                        body: formData,
                                    });
                                    const result = await res.json();

                                    if (result.status && result.success) {
                                        const fullUrl = normalizeUrl(ENDPOINT.base, result.image.path);
                                        const newFile = {
                                            uid: file.uid,
                                            name: file.name,
                                            status: "done",
                                            url: fullUrl,
                                            response: result,
                                        };
                                        setUploadList([newFile]);
                                        form.setFieldsValue({ image_url: [newFile] });
                                        onSuccess(result, file);
                                        message.success("Upload successful!");
                                    } else throw new Error(result.message || "Upload failed");
                                } catch (err) {
                                    onError(err);
                                    message.error("Upload failed: " + err.message);
                                }
                            }}
                            onRemove={() => {
                                setUploadList([]);
                                form.setFieldsValue({ image_url: [] });
                            }}
                            accept="image/jpeg,image/jpg,image/png,image/webp"
                        >
                            {uploadList.length === 0 && (
                                <div>
                                    <PlusOutlined />
                                    <div style={{ marginTop: 8 }}>Upload</div>
                                </div>
                            )}
                        </Upload>

                    </Form.Item>
                    

                    <Form.Item
                        name="status"
                        label="Status"
                        valuePropName="checked"
                    >
                        <Switch
                            checkedChildren="Active"
                            unCheckedChildren="Inactive"
                            style={{ transform: "scale(1.3)", marginLeft: "15px", marginTop: "4px" }}
                        />
                    </Form.Item>


                    <Form.Item>
                        <div style={{ textAlign: 'right', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                            <Button size='large' type="primary" htmlType="submit">
                                {editingItem ? 'Update' : 'Add'}
                            </Button>
                            <Button size='large' onClick={handleDrawerClose}>
                                Cancel
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
            </Drawer>
        </div>
    );
};

export default LetterHeader;